import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyContactCollectorGuest = loadable(() => import(/* webpackChunkName: "content/contactCollector/guest" */ '.'));
